interface PapacitoLogoProps {
  size?: 'small' | 'medium' | 'large';
  centered?: boolean;
}

export function PapacitoLogo({ size = 'medium', centered = true }: PapacitoLogoProps) {
  const sizes = {
    small: { text: 18, icon: 14, gap: 5 },
    medium: { text: 24, icon: 18, gap: 6 },
    large: { text: 32, icon: 24, gap: 8 },
  };

  const s = sizes[size];

  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: s.gap,
        justifyContent: centered ? 'center' : 'flex-start',
      }}
    >
      <svg width={s.icon} height={Math.round(s.icon * 1.2)} viewBox="0 0 20 24" fill="#e11d48">
        <path d="M10 1C10 1 5.5 7.5 5.5 12a4.5 4.5 0 009 0c0-2.2-1-4.4-2.2-5.8C12 8.5 11 10.5 11 12a1 1 0 01-2 0C9 9 10.5 6 10 1z" />
      </svg>
      <span
        style={{
          fontSize: s.text,
          fontWeight: 900,
          fontStyle: 'italic',
          background: 'linear-gradient(135deg, #e11d48 0%, #ec4899 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          letterSpacing: -0.5,
          lineHeight: 1,
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "SF Pro Display", "Helvetica Neue", sans-serif',
        }}
      >
        Papacito
      </span>
    </div>
  );
}
